// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubPhone {
    static getAttributeTypeMap() {
        return MangoHubPhone.attributeTypeMap;
    }
}
MangoHubPhone.discriminator = undefined;
MangoHubPhone.additionalProperties = false;
MangoHubPhone.attributeTypeMap = [
    {
        "name": "phoneTypeDescription",
        "baseName": "phoneTypeDescription",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "extension",
        "baseName": "extension",
        "type": "string"
    },
    {
        "name": "bestDaysToCall",
        "baseName": "bestDaysToCall",
        "type": "string"
    },
    {
        "name": "bestTimeToCall",
        "baseName": "bestTimeToCall",
        "type": "string"
    },
    {
        "name": "language",
        "baseName": "language",
        "type": "string"
    },
    {
        "name": "timeZone",
        "baseName": "timeZone",
        "type": "string"
    },
];
//# sourceMappingURL=mangoHubPhone.js.map